import React from 'react';
import {ActivityIndicator, View} from 'react-native';
import {noop} from 'lodash';

import {Shared} from '/constant/TestIDs';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {useTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';
interface LoadingIndicatorProps {
  getTheme: (key: string) => string;
  size: 'small' | 'large';
  style: Object;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  size = 'large',
  style: styleProp = {},
  getTheme = noop,
}) => {
  const color = getTheme('competency.backgroundColor.backgroundColor');
  const {ts} = useTranslation('loadingIndicator');
  return (
    <View
      accessibilityLabel={ts('loading.accessibilityLabel', 'Loading')}
      accessible={true}
      style={styleProp}
      {...testProperties(Shared.sharedLoadingIndicator)}>
      <ActivityIndicator size={size} color={color} />
    </View>
  );
};

export default withHOC(withTheme, withCompetency)(LoadingIndicator);
